import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/PropertiesStyles.css";
import API_URL from "../../config";

const Properties = () => {
  const [filter, setFilter] = useState("all");
  const [properties, setProperties] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // Modal
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [mainImage, setMainImage] = useState("");
  const [fullscreenImage, setFullscreenImage] = useState(null);

  // Al cambiar página/filtro, recargamos propiedades
  useEffect(() => {
    fetchProperties();
    // eslint-disable-next-line
  }, [currentPage, filter]);

  const fetchProperties = async () => {
    try {
      let statusParam = "all"; 
      if (filter === "sale") statusParam = "Venta";
      else if (filter === "rent") statusParam = "Arriendo";

      const response = await fetch(
        `${API_URL}/api/properties?page=${currentPage}&limit=6&status=${statusParam}`
      );
      const json = await response.json();

      setProperties(json.data || []);
      setCurrentPage(json.currentPage || 1);
      setTotalPages(json.totalPages || 1);
    } catch (err) {
      console.error("Error al cargar propiedades:", err);
    }
  };

  const handleFilterChange = (type) => {
    setFilter(type);
    setCurrentPage(1);
  };

  // Abre el modal y bloquea el scroll del body (opcional).
  const openModal = (property) => {
    setSelectedProperty(property);
    if (property.images && property.images.length > 0) {
      setMainImage(property.images[0]);
    } else {
      setMainImage("");
    }
    document.body.style.overflow = "hidden"; 
  };

  // Cierra el modal y restaura el scroll del body.
  const closeModal = () => {
    setSelectedProperty(null);
    setMainImage("");
    setFullscreenImage(null);
    document.body.style.overflow = "auto";
  };

  const changeMainImage = (image) => {
    setMainImage(image);
  };

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const subtitleText = {
    all: "Todas",
    sale: "En Venta",
    rent: "En Arriendo",
  };

  return (
    <main>
      {/* Placeholder del navbar */}
      <div className="navbar-placeholder"></div>

      {/* Filtros */}
      <section className="container px-1.5 py-3">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6">
            <h1 className="fw-light title-properties">PROPIEDADES</h1>
          </div>
          <div className="col-lg-6 col-md-6 d-flex justify-content-end">
            <button
              className="btn btn-filter mx-2"
              onClick={() => handleFilterChange("sale")}
            >
              En Venta
            </button>
            <button
              className="btn btn-filter mx-2"
              onClick={() => handleFilterChange("rent")}
            >
              En Arriendo
            </button>
            <button
              className="btn btn-filter mx-2"
              onClick={() => handleFilterChange("all")}
            >
              Todas
            </button>
          </div>
        </div>
      </section>

      {/* Subtítulo */}
      <section className="py-0 mt-4 subtitle-section">
        <h2 className="subtitle">
          {subtitleText[filter]}
          <span className="subtitle-divider"></span>
        </h2>
      </section>

      {/* Listado de Propiedades */}
      <div className="album py-5 custom-bg">
        <div className="container">
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
            {properties.map((property) => (
              <div
                key={property._id}
                className="col"
                onClick={() => openModal(property)}
                style={{ cursor: "pointer" }}
              >
                <div className="card shadow-sm">
                  {property.images && property.images[0] ? (
                    <img
                      src={`${API_URL}/uploads/${property.images[0]}`}
                      className="card-img-top"
                      alt={property.title}
                      style={{ objectFit: "cover", height: "200px" }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "200px",
                        backgroundColor: "#ccc",
                      }}
                    />
                  )}
                  <div className="card-body">
                    <h5 className="card-title">{property.title}</h5>
                    <p className="card-text">
                      <div>
                        <strong>Ubicación:</strong> {property.location}
                      </div>
                      <div>
                        <strong>Estado:</strong> {property.status}
                      </div>
                      <div>
                        <strong>Valor:</strong> $
                        {property.value?.toLocaleString()}
                      </div>
                    </p>
                    <button
                      className="btn btn-details btn-sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        openModal(property);
                      }}
                    >
                      Ver Detalles
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Paginación */}
          <div className="my-4 d-flex justify-content-center">
            <ul className="pagination">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => goToPage(currentPage - 1)}
                >
                  Anterior
                </button>
              </li>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                (pageNum) => (
                  <li
                    key={pageNum}
                    className={`page-item ${
                      pageNum === currentPage ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => goToPage(pageNum)}
                    >
                      {pageNum}
                    </button>
                  </li>
                )
              )}
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => goToPage(currentPage + 1)}
                >
                  Siguiente
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Modal de Detalles */}
      {selectedProperty && (
        <div
          className="custom-modal-overlay d-flex justify-content-center align-items-center"
          onClick={closeModal}
        >
          <div
            className="custom-modal-container"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Carrusel */}
            <div className="custom-modal-carousel">
              {selectedProperty.images?.length > 0 ? (
                <div
                  id="carouselPropControls"
                  className="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div className="carousel-inner h-100">
                    {selectedProperty.images.map((img, idx) => (
                      <div
                        key={idx}
                        className={`carousel-item ${idx === 0 ? "active" : ""}`}
                        onClick={() =>
                          setFullscreenImage({ img, index: idx })
                        }
                      >
                        <img
                          src={`${API_URL}/uploads/${img}`}
                          className="d-block w-100 h-100"
                          alt={`Imagen ${idx + 1}`}
                          style={{ objectFit: "contain" }}
                        />
                      </div>
                    ))}
                  </div>
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselPropControls"
                    data-bs-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Anterior</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselPropControls"
                    data-bs-slide="next"
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Siguiente</span>
                  </button>
                </div>
              ) : (
                <div style={{ color: "#fff", textAlign: "center" }}>
                  Sin Imagen
                </div>
              )}
            </div>

            {/* Detalles */}
            <div className="custom-modal-details p-4">
              <h3 className="custom-modal-title">{selectedProperty.title}</h3>
              <h4 className="text-price">
                ${selectedProperty.value?.toLocaleString()}
              </h4>
              <hr />
              <p className="custom-modal-location">
                <strong>Ubicación:</strong> {selectedProperty.location}
              </p>
              <p className="custom-modal-description">
                {selectedProperty.description}
              </p>
              <ul className="custom-modal-list">
                <li>
                  <strong>Área construida:</strong>{" "}
                  {selectedProperty.builtArea} m²
                </li>
                {selectedProperty.landArea && (
                  <li>
                    <strong>Área del terreno:</strong>{" "}
                    {selectedProperty.landArea} m²
                  </li>
                )}
                <li>
                  <strong>Habitaciones:</strong> {selectedProperty.bedrooms}
                </li>
                <li>
                  <strong>Baños:</strong> {selectedProperty.bathrooms}
                </li>
                <li>
                  <strong>Tipo de Propiedad:</strong>{" "}
                  {selectedProperty.propertyType}
                </li>
                <li>
                  <strong>Estado:</strong> {selectedProperty.status}
                </li>
              </ul>
            </div>

            {/* Botón cerrar */}
            <button
              className="custom-modal-close-btn"
              onClick={closeModal}
            >
              ✕
            </button>
          </div>
        </div>
      )}

      {/* Modal de Vista Ampliada (opcional) */}
      {fullscreenImage && (
        <div
          className="fullscreen-modal-overlay"
          onClick={() => setFullscreenImage(null)}
        >
          <div>
            <div className="fullscreen-carousel carousel slide h-100">
              <div className="carousel-inner h-100">
                {selectedProperty.images.map((img, idx) => (
                  <div
                    key={idx}
                    className={`carousel-item ${
                      fullscreenImage.index === idx ? "active" : ""
                    }`}
                  >
                    <img
                      src={`${API_URL}/uploads/${img}`}
                      className="d-block w-100 h-100"
                      alt={`Imagen ${idx + 1}`}
                      style={{ objectFit: "contain" }}
                    />
                  </div>
                ))}
              </div>
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target=".fullscreen-carousel"
                data-bs-slide="prev"
                onClick={(e) => e.stopPropagation()}
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Anterior</span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target=".fullscreen-carousel"
                data-bs-slide="next"
                onClick={(e) => e.stopPropagation()}
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Siguiente</span>
              </button>
            </div>
            <button
              className="fullscreen-modal-close-btn"
              onClick={() => setFullscreenImage(null)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </main>
  );
};

export default Properties;
